import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#8a8a8a]">loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}
